var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ma-0 error--text d-flex align-center",staticStyle:{"font-size":"0.8rem","height":"30px"}},[_c('span',[_vm._t("default",[_vm._v(_vm._s(_vm.error))],{"error":_vm.error})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }